import Modal from '@material-ui/core/Modal';
import IntegrityIcon from './svg/Integrity.svg';
import { useState } from 'react';
function Overlay(){

  let year = (new Date()).getFullYear();
  return (
    <div class="text-selectable" style={{padding:30,  userSelect:'auto'}}>

      <h1 class="sg-row v-center" style={{borderBottom:'1px solid #ccc',paddingBottom:10}}>
        <img style={{height:36}} src={IntegrityIcon}/>
        &nbsp;
        LabFigures Integrity Screener
      </h1>

      <div class="fair-margin-top">
        <div>
        Integrity Screener validates that your:
        </div>
        
        <br/>

        <ul>
          <li><i>Raw images</i> are truly <i>raw</i>.</li>
          <li>Images have proper controls (replicates, loading control, MW)?</li>
          <li>Figures will pass journal integrity checks?</li>
        </ul>

        <div>
          To get started, contact <a href="mailto:support@sciugo.com" target="_blank;">support</a>.
        </div>

      </div>




    </div>
  )
}

const color = "#f0f0f0";
let menuButtonStyle = { fontSize:12,
    background:color,
    display:'flex',
    alignItems:'center',
    lineHeight:0.5,
  padding:5,
    //marginLeft:5,
  }

export default function IntegrityButton(){

  const [ open, setOpen ] = useState(false);

  return (
    <>

      <div onClick={() => setOpen(true)} 
      style={menuButtonStyle} 
      class={"dark-hoverable round-corners tiny-margin clickable"}
      ><img style={{
        padding:0,
        margin:0,
      height:16
      }} src={IntegrityIcon} /></div>

    <Modal style={{
    width:'70%', left:'15%',
    height:'70%', top:'15%',
    border:'3px solid #eee',
    background:'white',
    borderRadius:4,
  }} 
    open={open} 
      onClose={() => setOpen(false)}>


    <div style={{background:'white', 
      borderRadius:4,
      height:'100%'}}>
      <Overlay/>
    </div>
  </Modal>
    </>
  )

  

  

}

